import React, { useCallback, useContext, useEffect, useState } from 'react';
import Select, { components, GroupBase, Props as SelectProps, StylesConfig } from 'react-select';
import { SelectComponentsConfig } from 'react-select/dist/declarations/src/components';
import { SearchHelper } from './search.helper';
import { OptionPhones } from './constant';
import { Theme } from '../../../theme/theme';

type TOption = {
  value: string;
  label: string;
  extra: string;
  code: string;
};

const Styles: StylesConfig<TOption, boolean> = {
  singleValue: (provided, state) => ({
    ...provided,
    color: Theme.inputTextColor,
  }),
  control: (provided, state) => ({
    ...provided,
    background: 'transparent',
    width: 'auto',
    height: '100%',
    marginLeft: 2,
    paddingLeft: 6,
    borderWidth: 0,
    outlineWidth: 0,
    boxShadow: '0 0 transparent',
    color: 'black',
  }),
  menu: (provided, state) => ({
    ...provided,
    width: 250,
    border: Theme.selectMenuBorder,
    borderRadius: Theme.selectMenuBorderRadius,
    overflow: 'hidden',
  }),
  placeholder: (provided, state) => ({
    ...provided,
    color: Theme.inputPHColor,
  }),
};

const Components: SelectComponentsConfig<TOption, false, GroupBase<TOption>> = {
  SingleValue: ({ children, ...rest }: any) => {
    const value = rest.getValue()[0];
    return <components.SingleValue {...rest}>{value.code}</components.SingleValue>;
  },
  DropdownIndicator: () => null,
  //IndicatorSeparator: () => null,
};

type Props<T = { value: string; label: string }> = SelectProps<T> & {
  disabled?: boolean;
  onChange?: (v: any) => void;
  onUserSelect: (v: any) => void;
};

const FormSelectCountryNoBorder = ({ value, onChange, onUserSelect, className, disabled, isMulti, ...rest }: Props) => {
  // @ts-ignore

  const selectedOption = value && OptionPhones.find((o) => o.value === value);
  const onChangeCB = useCallback((newOption, e) => {
    onChange?.(newOption.value);
    onUserSelect?.(newOption.value);
  }, []);

  return (
    // @ts-ignore // FIXME: type error
    <Select<TOption, false>
      {...rest}
      isMulti={false}
      isDisabled={disabled}
      menuPlacement={'auto'}
      value={selectedOption}
      defaultValue={selectedOption}
      onChange={onChangeCB}
      styles={Styles}
      components={Components}
      isSearchable={true}
      options={OptionPhones}
      filterOption={(option, inputValue) => {
        if (!inputValue) return true;
        const search = SearchHelper.getSearchFilter(inputValue);
        return option.data.extra.indexOf(search) >= 0;
      }}
    />
  );
};

export default FormSelectCountryNoBorder;
